export enum Gender {
  male = 'male',
  female = 'female',
  other = 'other'
}

export interface Player {
  name: string;
  age: number;
  gender: Gender;
  anxChoice: number;
  anxChoiceAfter: number;
  avatarIcon: number;
  wisdomCards: number;
}
